export enum NotificationTypes {
  ClientJoinEvent = 'client-join-event',
  ClientEventCancelled = 'client-event-cancelled',

  /** A visitor was turned away on the public page because the plan is used up. */
  PlanLimitPublicRefusal = 'plan-limit-public-refusal',

  ClientReservationCreated = 'client-reservation-created',
  ClientReservationCancelled = 'client-reservation-cancelled',
}
